// extracted by mini-css-extract-plugin
export var copyableField = "_rh-4";
export var customerBadge = "_rh-0";
export var customerInfoTitle = "_rh-2";
export var details = "_rh-1";
export var dropdownContainer = "_rh-5";
export var dropdownImage = "_rh-6";
export var editAssigneeForm = "_rh-a";
export var editButton = "_rh-3";
export var email = "_rh-7";
export var hidden = "_rh-d";
export var input = "_rh-8";
export var saveButton = "_rh-b";
export var shopifyIcon = "_rh-c";
export var suggestionBadge = "_rh-e";
export var suggestionText = "_rh-f";
export var username = "_rh-9";